import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import type { AnyObject, InferType, ObjectSchema } from 'yup';

interface FormProps<TSchema extends ObjectSchema<AnyObject>> {
  schema?: TSchema;
  defaultValues?: Partial<InferType<TSchema>>;
  onSubmit: (data: InferType<TSchema>) => void | Promise<void>;
  children: React.ReactNode;
  [key: string]: unknown;
}

function Form<TSchema extends ObjectSchema<AnyObject>>({
  schema,
  defaultValues,
  onSubmit,
  children,
  ...props
}: FormProps<TSchema>) {
  const methods = useForm({
    resolver: schema ? yupResolver(schema) : undefined,
    defaultValues: defaultValues as never
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        {...(props as React.FormHTMLAttributes<HTMLFormElement>)}
      >
        {children}
      </form>
    </FormProvider>
  );
}

export default Form;
